<script lang="ts" setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { Actions, Mutations, ShiftCMSState } from '@/store';
import { Drawer } from '@/models/drawer.model';

const store = useStore<ShiftCMSState>();

const drawer = computed<Drawer>(() => store.state.drawer);
const subDrawer = computed<Drawer>(() => store.state.subDrawer);

const dirtyState = computed<boolean>(() => store.state.dirtyState);

const hideDrawer = () => {
  if (dirtyState.value) {
    store.dispatch(Actions.ShowNotification, {
      message: 'You have unsaved changes',
      type: 'warning',
    });
    return;
  }
  store.commit(Mutations.HideSubDrawer);
  store.commit(Mutations.HideDrawer);
};
const hideSubDrawer = () => {
  store.commit(Mutations.HideSubDrawer);
};
</script>
<template>
  <div class="drawer-backdrop" v-if="drawer.show" @click="hideDrawer"></div>
  <div
    class="drawer"
    :class="{
      show: drawer.show,
      medium: drawer.medium,
      double: subDrawer.show,
      half: subDrawer.small,
    }"
  >
    <v-btn
      icon="mdi-close-circle-outline"
      density="compact"
      class="close-button"
      @click.prevent="hideDrawer"
    ></v-btn>
    <component :is="drawer.component" :data="drawer.data" />
  </div>
  <div
    class="drawer sub-drawer"
    :class="{ show: subDrawer.show, 'drawer-small': subDrawer.small }"
  >
    <v-btn
      icon="mdi-close-circle-outline"
      density="compact"
      class="close-button"
      @click.prevent="hideSubDrawer"
    ></v-btn>
    <component :is="subDrawer.component" :data="subDrawer.data" />
  </div>
</template>
<style scoped>
.drawer-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.15);
  z-index: 200;
}

.drawer {
  position: fixed;
  z-index: 201;
  width: 800px;
  height: 100%;
  overflow-y: scroll;
  background-color: white;
  top: 0;
  right: -800px;
  transition: right 0.35s;
  box-shadow: 2px -2px 6px rgb(131, 131, 131);
}

.sub-drawer {
  z-index: 201;
}

.drawer.show {
  right: 0;
}

.drawer.medium {
  width: 600px;
}

.drawer.drawer-small {
  width: 400px;
}

.drawer.double {
  right: 800px;
}

.drawer.half {
  right: 400px;
}

.close-button {
  position: absolute;
  top: 1em;
  right: 1em;
  z-index: 100;
}
</style>
